import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ImageLazyLoad, FeedImage } from '../../';

import './styles.scss';

const propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  camId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  slideNumber: PropTypes.number,
  imgSrc: PropTypes.string,
  imgWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  imgHeight: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  fallbackImgSrc: PropTypes.string,
  lazyLoad: PropTypes.bool,
  template: PropTypes.string,
  feedImage: PropTypes.bool,
};

const defaultProps = {
  className: '',
  to: '#',
  camId: '',
  slideNumber: 0,
  imgSrc: '',
  imgWidth: 254,
  imgHeight: 143,
  fallbackImgSrc: '',
  lazyLoad: true,
  template: null,
  feedImage: false,
};

class ImageDetails extends React.Component {

  constructor(props) {
    super(props);
    this.onHandleClick = this.onHandleClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.className !== nextProps.className || this.props.isActive !== nextProps.isActive || this.props.imgSrc !== nextProps.imagSrc;
  }

  onHandleClick(callback) {
    if (typeof callback === 'function') {
      callback(arguments);
    }
  }

  render() {
    const {
      className,
      to,
      camId,
      onHandleClick,
      slideNumber,
      imgSrc,
      imgWidth,
      fallbackImgSrc,
      lazyLoad,
      feedImage,
      children,
    } = this.props;
    const imgHeight = 'auto';
    const loaderProps = { style: { height: imgHeight, paddingTop: 25 }, dark: true };

    return (
      <Link className="cam-item" to={to} onClick={onHandleClick} data-cam-id={camId} data-slide-number={slideNumber}>
        {
            feedImage ?
              <FeedImage
                src={imgSrc}
                style={{ height: imgHeight, width: imgWidth }}
                loaderProps={loaderProps}
                fallbackImgSrc={fallbackImgSrc}
              /> :
              <ImageLazyLoad
                src={imgSrc}
                minHeight={imgHeight}
                loaderProps={loaderProps}
                style={{ height: imgHeight, width: imgWidth }}
                fallbackImgSrc={fallbackImgSrc}
                loadOnlyOnce
                lazyLoad={lazyLoad}
              />
          }
        <div className="cam-item-overlay d-flex align-items-center justify-content-center">
          <div className="cam-item-inner">
            {children}
          </div>
        </div>
      </Link>
    );
  }
}

ImageDetails.propTypes = propTypes;
ImageDetails.defaultProps = defaultProps;

export default ImageDetails;
